<template>
  <div>
    <a-row>
      <g-master name="poll_category"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="ParentData"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Nombre corto')">
                <a-input
                  v-decorator="['short_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Descripción')">
                <a-input
                  v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['active', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="2">
        <a-tab-pane tab="PREGUNTAS" key="1">
          <mantenimiento-poll-question v-if="idForm" :id="idForm"></mantenimiento-poll-question>
          <span v-else>Seleccione una categoría para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'poll_category',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre corto', dataIndex: 'short_name', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'active', type: 'boolean'},
            {name: 'description'},
            {name: 'short_name'}
          ]
        }
      }
    },
    props: ['id'],
    computed: {
      ParentData () {
        return {
          id_poll: this.id
        }
      },

      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Poll/PollCategory.vue